export default __webpack_public_path__ + "3c4e083b77e7ce8f7e4e03cedaee57da.png";